import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  transform(value: number): string {
    if (value === null) return ''
    return new Intl.NumberFormat('en-US').format(value);
  }

}
